import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-toast',
  template: `
    <div *ngIf="isVisible" class="custom-toast" [ngClass]="type">
      <p>{{ message }}</p>
    </div>
  `,
  styleUrls: ['./toast.component.scss']
})
export class ToastComponent {
  @Input() message: string = '';
  @Input() type: string = 'error'; // default to error
  isVisible: boolean = false;

  // Method to show the toast and hide it after 5 seconds
  showToast(message: string, type: string) {
    this.message = message;
    this.type = type;
    this.isVisible = true;

    // Set timeout to hide the toast after 5 seconds
    setTimeout(() => {
      this.isVisible = false;
    }, 5000); // 5000 ms = 5 seconds
  }
}
